export default "__VITE_ASSET__e0fcab57__"